export default "__VITE_ASSET__d8ebb104__"